export type FeedbackStatus = "not_reviewed" | "reviewing" | "completed"

export const FEEDBACK_STATUSES: { value: FeedbackStatus; label: string }[] = [
  { value: "not_reviewed", label: "Not reviewed" },
  { value: "reviewing", label: "Reviewing" },
  { value: "completed", label: "Completed" },
]

export type FeedbackCategory = "bug" | "confusing" | "content" | "idea" | "other"

/** Message ids for the sender-facing category labels (the admin screens keep the English ones below). */
export const FEEDBACK_CATEGORY_MESSAGES: Record<FeedbackCategory, { id: string }> = {
  bug: { id: "feedback.categories.bug" },
  confusing: { id: "feedback.categories.confusing" },
  content: { id: "feedback.categories.content" },
  idea: { id: "feedback.categories.idea" },
  other: { id: "feedback.categories.other" },
}

export const FEEDBACK_CATEGORIES: { value: FeedbackCategory; label: string }[] = [
  { value: "bug", label: "Something's broken" },
  { value: "confusing", label: "Confusing" },
  { value: "content", label: "Wrong or outdated content" },
  { value: "idea", label: "Idea or suggestion" },
  { value: "other", label: "Something else" },
]

export type FeedbackSummary = {
  id: number
  message: string
  status: FeedbackStatus
  category: FeedbackCategory
  has_screenshot: boolean
  page_path: string | null
  user_email: string | null
  created_at: string
}

export type FeedbackReply = {
  id: number
  kind: "reply" | "resolved"
  body: string | null
  to_email: string
  sender_email: string | null
  created_at: string
}

export type FeedbackDetail = FeedbackSummary & {
  page_title: string | null
  user_agent: string | null
  user_id: number | null
  contact_email: string | null
  reply_email: string | null
  replies: FeedbackReply[]
  admin_notes: string
  updated_at: string
}
